import { useMutation } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';

type SeriesVariable = {
	seriesName: string;
	variables?: string[] | null;
};

type ExportSeriesResult = {
	signedUrl: string;
};

export type ExportSeriesMutationArgs = {
	projectId: string;
	seriesVariables: SeriesVariable[];
	fileType: 'csv' | 'xlsx';
	useCategoryLabels: boolean;
	timezone?: 'yes' | 'no' | 'utc';
	splitMultipleCategories?: boolean;
	includeSystemVariables?: boolean;
	includeVariableTypes?: boolean;
	includeCodelistCustomId?: boolean;
	mainVariables?: string[] | null;
};

export const useExportSeriesMutation = () => {
	return useMutation({
		mutationFn: async ({
			projectId,
			seriesVariables,
			fileType,
			useCategoryLabels,
			timezone = 'yes',
			splitMultipleCategories = false,
			includeSystemVariables = false,
			includeVariableTypes = false,
			includeCodelistCustomId = false,
			mainVariables
		}: ExportSeriesMutationArgs) => {
			const result: ExportSeriesResult = await makeRequest({
				method: 'exportSeries',
				service: 'stats',
				data: {
					projectId,
					seriesVariables,
					fileType,
					useCategoryLabels,
					timezone,
					splitMultipleCategories,
					includeSystemVariables,
					includeVariableTypes,
					includeCodelistCustomId,
					mainVariables
				}
			});

			return result;
		}
	});
};
